import React from 'react';
import { Plus } from 'lucide-react';
import { cn, isMobileDevice } from '@/lib/utils';
import { useHaptics } from '@/hooks/useHaptics';

interface FABProps {
  onClick: () => void;
  className?: string;
}

const FAB: React.FC<FABProps> = ({ onClick, className }) => {
  const { lightImpact } = useHaptics();
  const isMobile = isMobileDevice();

  const handleClick = () => {
    if (isMobile) {
      lightImpact();
    }
    onClick();
  };

  return (
    <button
      onClick={handleClick}
      className={cn(
        // Base styles
        "fixed z-30 flex items-center justify-center transition-all duration-200",
        // Position
        "bottom-24 right-6",
        // Mobile styling
        isMobile 
          ? "w-14 h-14 rounded-full bg-primary shadow-2xl backdrop-blur-xl border border-white/20 active:scale-95" 
          : "w-12 h-12 rounded-full bg-primary shadow-lg hover:shadow-xl active:scale-95",
        // Focus states
        "focus:outline-none focus:ring-2 focus:ring-primary/50 focus:ring-offset-2",
        className
      )}
      aria-label="Add recipe"
    >
      <Plus 
        className={cn(
          "text-primary-foreground",
          isMobile ? "h-6 w-6" : "h-5 w-5"
        )} 
      />
    </button>
  );
};

export default FAB;
